import { readonly, ref } from "vue";





const height = ref(0);

export function usePaddingHelper() {
  const setHeight = (heightValue: number) => {
    height.value = heightValue;
  }

  return { setHeight, height: readonly(height) };
}
